import {
    getHirePackages,
    getInsuranceIncluded,
    getVehicleDisplayName,
    getVehicleFuel,
    getVehicleLicensingAuthority,
    getVehicleMake,
    getVehicleModel,
    getVehicleTags,
    vehicleOffersInsurancePackage,
    vehicleOffersUninsuredPackage,
} from "./vehicleHelpers"
import { LICENSING_AUTHORITIES } from "../constants/licensingAuthorities"

export {
    getHirePackages,
    getInsuranceIncluded,
    getVehicleDisplayName,
    getVehicleFuel,
    getVehicleLicensingAuthority,
    getVehicleMake,
    getVehicleModel,
    getVehicleTags,
    vehicleOffersInsurancePackage,
    vehicleOffersUninsuredPackage,
}

export const parseVehicleName = (name = "") => {
    const parts = name.trim().split(/\s+/)
    return {
        make: parts[0] || "",
        model: parts.slice(1).join(" "),
    }
}

export const DEFAULT_VEHICLE_FILTERS = {
    authority: "",
    make: "",
    model: "",
    fuel: "",
    tag: "",
    insurance: "",
}

export const getFilterOptions = (cars) => {
    const makes = new Set()
    const modelsByMake = {}
    const allModels = new Set()
    const fuels = new Set()
    const tags = new Set()
    const authorities = new Set(LICENSING_AUTHORITIES)

    cars.forEach((car) => {
        const make = getVehicleMake(car)
        const model = getVehicleModel(car)
        if (make) {
            makes.add(make)
            if (!modelsByMake[make]) modelsByMake[make] = new Set()
            if (model) modelsByMake[make].add(model)
        }
        if (model) allModels.add(model)

        const fuel = getVehicleFuel(car)
        if (fuel) fuels.add(fuel)

        getVehicleTags(car).forEach((tag) => tags.add(tag))

        const authority = getVehicleLicensingAuthority(car)
        if (authority) authorities.add(authority)
    })

    const sortAlpha = (items) => [...items].sort((a, b) => a.localeCompare(b))

    return {
        makes: sortAlpha(makes),
        models: sortAlpha(allModels),
        modelsByMake: Object.fromEntries(
            Object.entries(modelsByMake).map(([make, models]) => [make, sortAlpha(models)])
        ),
        fuels: sortAlpha(fuels),
        tags: sortAlpha(tags),
        authorities: sortAlpha(authorities),
    }
}

export const filterVehicles = (cars, filters) =>
    cars.filter((car) => {
        const make = getVehicleMake(car)
        const model = getVehicleModel(car)
        const fuel = getVehicleFuel(car)
        const tags = getVehicleTags(car)
        const authority = getVehicleLicensingAuthority(car)

        if (filters.authority && authority !== filters.authority) return false
        if (filters.make && make !== filters.make) return false
        if (filters.model && model !== filters.model) return false
        if (filters.fuel && fuel !== filters.fuel) return false
        if (filters.tag && !tags.includes(filters.tag)) return false

        if (filters.insurance === "included" && !vehicleOffersInsurancePackage(car)) return false
        if (filters.insurance === "not_included" && !vehicleOffersUninsuredPackage(car)) return false

        return true
    })

export const hasActiveFilters = (filters) =>
    Object.values(filters).some((value) => Boolean(value))
